// removed by extract-text-webpack-plugin
module.exports = {"page-container":"_33-1wvY0JeWJAFeH2JADhW","pageContainer":"_33-1wvY0JeWJAFeH2JADhW","offline-button":"_2IoTKMQCg6nv-c0SjUhqb-","offlineButton":"_2IoTKMQCg6nv-c0SjUhqb-","offline-text":"_1TkDaJ0r4b55QOLsdLrVxB","offlineText":"_1TkDaJ0r4b55QOLsdLrVxB","offline-retry-button":"_3x2lYPV3Jyf6-7ghlvgyiY","offlineRetryButton":"_3x2lYPV3Jyf6-7ghlvgyiY"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/offline/offlinePage.css
// module id = 544
// module chunks = 0